import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "swatch"]

  connect() {
    this.syncSelectedState(this.currentColor())
  }

  select(event) {
    event.preventDefault()

    const color = event.currentTarget.dataset.color
    if (!color || !this.hasInputTarget) return

    this.inputTarget.value = color
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.syncSelectedState(color)
  }

  currentColor() {
    if (this.hasInputTarget && this.inputTarget.value) return this.inputTarget.value
    if (!this.hasSwatchTarget) return null

    return this.swatchTargets[0].dataset.color
  }

  syncSelectedState(selectedColor) {
    if (!selectedColor && this.hasSwatchTarget) {
      selectedColor = this.swatchTargets[0].dataset.color
      if (this.hasInputTarget) this.inputTarget.value = selectedColor
    }

    this.swatchTargets.forEach((swatch) => {
      const selected = swatch.dataset.color === selectedColor
      swatch.setAttribute("aria-pressed", selected ? "true" : "false")
      swatch.style.boxShadow = selected
        ? "0 0 0 2px #0f172a, inset 0 0 0 2px rgba(255,255,255,0.9)"
        : "0 0 0 1px rgba(148,163,184,0.45), inset 0 0 0 1px rgba(255,255,255,0.75)"
    })
  }
}
